var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetaCima(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.65187 1.61187C2.56435 1.61187 2.4934 1.54092 2.4934 1.45339C2.4934 1.36587 2.56435 1.29492 2.65187 1.29492H12.2466C12.3342 1.29492 12.4051 1.36587 12.4051 1.45339V11.1634C12.4051 11.2509 12.3342 11.3219 12.2466 11.3219C12.1591 11.3219 12.0882 11.2509 12.0882 11.1634V1.83598L1.26565 12.6585C1.20376 12.7204 1.10342 12.7204 1.04153 12.6585C0.979645 12.5966 0.979645 12.4963 1.04153 12.4344L11.8641 1.61187H2.65187Z",
    fill: "#16A34A",
    stroke: "#16A34A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetaCima);
export default __webpack_public_path__ + "static/media/setaCima.42bedb994047a259ee2687478dcda85f.svg";
export { ForwardRef as ReactComponent };